export default __webpack_public_path__ + "cb6da318d1ab8edf89bc42313da9e30c.png";